/**
 * 中文语言包
 */
export default {
  appName: "PowerCoin",
  home_title: "首页",

  //#region 主题
  theme: {
    light: "亮色",
    dark: "暗色",
  },
  //#endregion

  //#region 错误提示
  error: {
    emailError: "邮箱格式错误!",
  },
  //#endregion

  //#region 路由

  route: {
    common: {
      please_select_file: "请选择上传文件",
      upload_success:"上传成功"
    },
    home: "首页",
    hangqing: {
      title: "行情",
      tabs: {
        zfb: "涨幅榜",
        dfb: "跌幅榜",
      },
      tabs_item: {
        jyd: "交易对",
        zxj: "最新价",
        zd: "最低",
        zg: "最高",
        zf24h: "24H涨幅",
        cjl: "成交量",
      },
    },
    contract: {
      title: "合约",
      yue: "余额",
      yjzsr: "预计总收入",
      fxl: "风险率",
      ytj: "已提交!",
    },
    options: {
      title: "期权",
    },
    transaction: {
      title: "现货",
      yue: "余额",
      yjzsr: "预计总收入",
      fxl: "风险率",
      ytj: "已提交!",
    },
    me: {
      title: "我的",
      zzc: "总资产",
      chongzhi: "充值",
      tixian: "提现",
      zhuanzhang: "转账",
      tuichu: "退出",
      unlogin_desc: "您确定要退出登录么?",
      ytcdl: "已退出登录",

      menus: {
        daikuan: "贷款",
        daikuan_desc: "一站式贷款服务入口",
        zichan: "资产",
        zichan_desc: "查看账户持有的币种及总资产",
        lishi: "历史",
        lishi_desc: "查看您的全部交易记录",
        zjls: "资金流水",
        zjls_desc: "查看您的全部资金流水",
        kf: "客服",
        kf_desc: "联系平台客服",
        txmm: "提现密码",
        txmm_desc: "设置您的提现密码",
        ptjj: "平台简介",
        ptjj_desc: "了解平台背景与核心优势",
        czmm: "重置密码",
        czmm_desc: "修改登录密码，保障账户安全",
        kyc: "KYC Certification",
        kyc_desc: "完成实名认证，解锁更多权限",
        tcdl: "退出登录",
      },
    },
    about: {
      title: "关于",
    },
    recharge: {
      title: "充值",
      save_qr: "保存二维码",
      copy_address: "复制地址",
      cbsl: "充币数量",
      yjdz: "预计到账",
      llx: "链类型",
      wu: "无",
      ndzzhx: "您的转账哈希",
      tijiao: "提交",
      qsr_cbsl: "请输入充币数量",
      qsrzz_hash: "请输入转账哈希",
      czsq_ytj: "充值申请已提交!",
      copy_success: "复制成功",
      copy_error: "复制失败!",
      notfind_qr: "没有找到二维码",
    },
    transfer: {
      title: "转账",
      zzsl: "转账数量",
      all: "全部",
      keyong: "可用",
      zy_zichan: "转移资产",
      wallet: "钱包",
      contract_wallet: "合约钱包",
      option_wallet: "期货钱包",
      xianhuo_wallet: "现货钱包",
      zy_success: "转移成功",
    },
    withdraw: {
      title: "提现",
      tibi: "提币",
      to_szhb_address: "数字货币地址",
      select_bz: "选择币种",
      qkl_network: "区块链网络",
      address: "地址",
      shuliang: "数量",
      all: "全部",
      keyong: "可用",
      kdzsl: "可到账数量",
      txfy: "提现费用",
      sxf: "手续费",
      tx: "提现",
      set_txmm: "设置提现密码",
      txysq: "提现已申请",
    },
    transaction_record: {
      title: "交易记录",
    },
    lever_record: {
      title: "杠杆记录",
    },
    myassets: {
      title: "我的资产",
      zzc: "总资产",
      hyye: "合约余额",
      qqye: "期权余额",
      xhye: "现货余额",
      qbye: "钱包余额",
    },
    fund_flowing_water: {
      title: "资金流水",
      tabs: {
        chongzhi: "充值",
        tixian: "提现",
      },
      cz: {
        danhao: "单号",
        zffs: "支付方式",
        czlx: "充值类型",
        bz: "币种",
        czsl: "充值数量",
        sjjz: "实际价值",
        ysjg: "原始价格",
        dj: "单价",
        ddzt: "订单状态",
        czdz: "充值地址",
        czhash: "充值Hash",
        wcsj: "完成时间",
        cjsj: "创建时间",
      },
      tx: {
        txdh: "提现单号",
        txje: "提现金额",
        sxf: "手续费",
        sjdzje: "实际到账金额",
        zt: "状态",
        shbz: "审核备注",
        shsj: "审核时间",
        dksj: "打款时间",
        cjsj: "创建时间",
      },
      recharge_method: {
        on_chain: "链上充值",
        bank_transfer: "银行转账",
        wechat: "微信支付",
        alipay: "支付宝支付",
        offline: "线下打款",
        admin_manual: "后台手动加款",
        third_party_sdk: "第三方SDK支付",
        internal_balance: "内部余额转账",
        gift: "赠送充值",
      },
      order_status: {
        pending: "待付款",
        paid: "已付款(待处理)",
        processing: "处理中",
        completed: "已完成",
        cancelled: "已取消",
        failed: "支付失败",
        refunded: "已退款",
      },
      withdraw_status: {
        pending: "待审核",
        approved: "审核通过",
        paid: "已打款",
        rejected: "拒绝",
        cancelled: "取消",
      },
    },
    kyc: {
      title: "实名认证",
      sjmc: "实际名称",
      qsrzsmc: "请输入真实名称",
      sjhm: "手机号码",
      qsrsjh: "请输入手机号",

      jszz_sfz: "驾驶执照/身份证",
      qsr_jszz_sfz: "请输入驾驶执照/身份证",
      zmz: "正面照",
      bmz: "背面照",
      zt: "状态:",
      qr: "确认",
      wsh: "未审核",
      yjj: "已拒绝",
      ytt: "已通过",
      qsczjzmz: "请上传证件正面照",
      qsczjfmz: "请上传证件反面照",
      tjcg: "提交成功",
    },
    loans: {
      title: "贷款",
      ndzsed: "您的专属额度",
      qsrdkje: "请输入贷款金额",
      fw: "范围",
      jyzq: "借用周期",
      rll: "日利率",
      lx: "利息",
      hkfs: "还款方式",
      dkjg: "贷款机构",
      submit: "提交",
      sccczm: "上传财产证明"
    },
    kline: {
      title: "K线",
      mairu: "买入",
      maichu: "卖出",
    },
  },
  components: {
    LoginComponent: {
      phone: "请输入手机号码",
      emailorphone: "请输入电子邮件",
      login: "登录",
      register: "注册",
      wjmm: "忘记密码?",
      qsrmm: "请输入密码",
      dzyj: "请输入电子邮件",
      email_code: "EMALL验证码",
      fasong: "发送",
      dlmm: "登录密码",
      yqm: "邀请码",
      ljzc: "立即注册",
      yyzh: "已有账户?",
      qudenglu: "去登录",
      qrmm: "确认密码",
      queren: "确认",
      sjhbnwk: "手机号码不能为空",
      mmbnwk: "密码不能为空",
      qsryx: "请输入邮箱!",
      yzmyfs: "验证码已发送!",
      zccg: "注册成功!",
      czmmcg: "重置密码成功!",
    },
    HeaderComponent: {
      home: "首页",
      heyue: "合约",
      qiquan: "期权",
      xianhuo: "现货",
      wode: "我的",
      ptjj: "平台简介",
      dingyue: "订阅",
      about: "关于",
    },
    HomeComponent: {
      controller: {
        danjia: "单价",
        zdsl: "最大数量",
        meiyuan: "美元",
        qxztzcp: "请选择投资产品",
        qxzgg: "请选择杠杆",
        ljtz: "立即投资",
        quxiao: "取消",
      },
      contents: {
        jiage: "价格",
        lirun: "利润",
        mrzdxdl: "每日最大下单量",
        ljtz: "立即投资",

        t1: "数据驱动。人工智能驱动。量化掌握。",
        t2: "更明智的投资从这里开始。",
        t3: "融合了战略、数据和人工智能，为现代市场提供可作的量化解决方案。",
        t4: "探索人工智能驱动的量化投资计划",
        t5: "为什么选择",
        t6: "安全与合规",
      },
      xzlist: {
        t1: "全面风险控制集成",
        t1_desc: "风险被衡量、建模和管理。",
        t2: "实时市场分析",
        t2_desc: "通过实时数据驱动的决策保持领先。",
        t3: "人工智能驱动的量化策略",
        t3_desc: "尖端人工智能为每项投资决策提供支持。",
        t4: "财务专家支持",
        t4_desc: "由经验丰富的量化和人工智能专业人士构建。",
        t5: "稳定的回报潜力",
        t5_desc: "旨在在所有市场条件下获得可靠的回报。",
        t6: "全球多元化资产",
        t6_desc: "将您的风险分散到多个全球市场。",
      },
      aqhglist: {
        t1: "受监管和许可的交易平台",
        t2: "所有交易均采用银行级加密",
        t3: "即时提款和完全透明",
      },
    },
    BottomComponent: {
      menus: {
        hangqing: "行情",
        heyue: "合约",
        qiquan: "期权",
        xianhuo: "现货",
        wode: "我的",
      },
    },
    EmptyComponent: {
      empty_data: "暂无数据",
    },
    AIOrderTaskWindow: {
      title: "AI订单",
      rwd: "任务单",
      cp: "产品",
      gmfy: "购买费用",
      zsy: "总收益",
      rws: "任务数",
      yxsj: "运行时间",
      startTime: "启动时间",
      overTime: "结束时间",
      active: "运行中",
      pending: "等待中",
      finish: "已完成",
    },
    OrderTaskWindow: {
      tabs: {
        heyue: "合约",
        qiquan: "期权",
        xianhuo: "现货",
      },
      item: {
        buy: "买入",
        sell: "卖出",
        shou: "手",
        kaipanjia: "开盘价",
        zhiyingjia: "止盈价",
        zhisunjia: "止损价",
        shouxufei: "手续费",
        baozhengjin: "保证金",
        sunyi: "损益",
        zhuangtai: "状态",
        jiesuanzhuangtai: "结算状态",
        lrssl: "利润损失率",
        kfsj: "开放时间",
        gbsj: "关闭时间",
        pcj: "平仓价",
        zhang: "涨",
        die: "跌",
        fangxiang: "方向",
        sxlx: "时效类型",
        sxx: "时效性",
        ccsj: "创仓时间",
        bcsj: "闭仓时间",
        tzje: "投资金额",
        rcjg: "入仓价格",
        pcjg: "平仓价格",
        ykje: "盈亏金额",
        czfs: "操作方式",
        cjsj: "创建时间",
        cje: "成交额",
        mmsl: "买卖数量",
        cjze: "成交总额",
        sxf: "手续费",
        xdsj: "下单时间",
        chengjiaosj: "成交时间",
        xdly: "下单来源",
      },
    },
    CurrencyListComponent: {
      yx: "永续",
      hy: "合约",
      mc: "名称",
      zxjg_24hzd: "最新价/24H涨跌",
    },
    ContractCenterConsoleComponent: {
      buy: "购买",
      sell: "出售",
      jyfs: "交易方式",
      ganggan: "杠杆",
      dqzyjg: "当前最优价格",
      gdje: "固定金额",
      scjg: "市场价格",
      jysl: "交易数量",
      gdjg: "固定金额",
      ky: "可用",
      kjy: "可交易",
      shou: "手",
      bzj: "保证金",
      xdcg: "下单成功!",
      mrdt: "买入(多头)",
      mczk: "卖出(做空)",
    },
    RealTimePriceCompnent: {
      jg: "价格",
      sl: "数量",
    },
    ContractHoldingPositionComponent: {
      zhisun: "止损",
      zyjg: "止盈价格",
      qsrzyjg: "请输入止盈价格",
      zsjg: "止损价格",
      qsrzsjg: "请输入止损价格",
      quxiao: "取消",
      queding: "确定",
      jiaoyi: "交易",
      weituo: "委托",
      yiguanbi: "已关闭",
      yichexiao: "已撤销",
      buy: "购买",
      sell: "卖出",
      shou: "手",
      kaipanjia: "开盘价",
      zhiyingjia: "止盈价",
      zhisunjia: "止损价",
      baozhengjin: "保证金",
      sunyi: "损益",
      shouxufei: "手续费",
      kaipanshijian: "开盘时间",
      lirunsunshilv: "利润损失率",
      setzs: "设置止损",
      dangqianjiage: "当前价格",
      pingcang: "平仓",
      quxiaodingdan: "取消订单",
      kaifangshijian: "开放时间",
    },
    KLineComponent: {
      "24hzgj": "24H最高价",
      "24hcjl": "24H成交量",
      "24hzdj": "24H最低价",
      "24hcje": "24H成交额",
      time: "时间:",
      open: "开:",
      high: "高:",
      low: "低:",
      close: "收:",
      volume: "成交量:",
      change: "涨幅:",
      turnover: "成交额:",
    },
    RecentTransactionsComponent: {
      zjjy: "最近交易",
      jiage: "价格",
      shuliang: "数量",
    },
    OrderListComponent: {
      title: "我的订单",
      fuhao: "符号",
      touzijuece: "投资决策",
      zhixingjiage: "执行价格",
      jiesuanjiage: "结算价格",
      chengjiaoriqi: "成交日期",
      shouru: "收入",
      jiesuanriqi: "结算日期",
    },
    OptionsCenterConsoleComponent: {
      jyjg: "交易结果",
      cjrq: "成交日期",
      jsrq: "结算日期",
      zxjg: "执行价格",
      jsj: "结算价",
      tz: "投资",
      sr: "收入",
      queding: "确定",
      qx: "取消",
      tzjc: "投资决策",
      lr: "利润",
      konggu: "控股",
      history: "历史",
      close: "关闭",
      daoqi: "到期",
      hqsjsb: "获取数据失败!",
      tzjebxdy0: "投资金额必须大于0!",
      cpsjyc: "产品数据异常!",
      cjqqcg: "创建期权成功!",
    },
    TransactionCenterConsoleComponent: {
      buy: "购买",
      sell: "出售",
      jyfs: "交易方式",
      gdje: "固定金额",
      dqzyhjg: "当前最优惠价格",
      jysl: "交易数量",
      jyl: "交易量",
      mrdt: "买入(多头)",
      mczk: "卖出(做空)",
      scjg: "市场价格",
      gdjg: "固定价格",
    },
    TransactionRecordComponent: {
      zs: "止损",
      zyjg: "止盈价格",
      qsrzyjg: "请输入止盈价格",
      zsjg: "止损价格",
      qsrzsjg: "请输入止损价格",
      quxiao: "取消",
      queren: "确认",
      jiaoyi: "交易",
      weituo: "委托",
      yiguanbi: "已关闭",
      yichexiao: "已撤销",
      buy: "购买",
      sell: "卖出",
      shou: "手",
      kaipanjia: "开盘价",
      zhiyingjia: "止盈价",
      zhisunjia: "止损价",
      baozhengjin: "保证金",
      sunyi: "损益",
      shouxufei: "手续费",
      kaipanshijian: "开盘时间",
      lirunsunshilv: "利润损失率",
      setzs: "设置止损",
      dangqianjiage: "当前价格",
      pingcang: "平仓",
      quxiaodingdan: "取消订单",
    },
    WithdrawPwdComponent: {
      txmmsz: "提现密码设置",
      oldpwd: "旧密码",
      newpwd: "新密码",
      querenpwd: "确认密码",
      qsrjmm: "请输入旧密码",
      qsrxmm: "请输入新密码",
      qsrqrmm: "请输入确认密码",
      save: "保存",
    },
    ResetPasswordComponent: {
      email: "电子邮件",
      mail_code: "邮件验证码",
      fasong: "发送",
      dlmm: "登录密码",
      qrmm: "确认密码",
      qrcz: "确认重置",
      quxiao: "取消",
      qsr_email: "请输入邮箱!",
      yzmyfs: "验证码已发送!",
      czmmcg: "重置密码成功!",
    },
  },

  //#endregion
};
